import React from 'react';

import { Button } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import actions from '../Actions';

export default function SlackNotLinked() {
  const { state: stateUsers } = useUsersContext();

  const clientId = '183357387571.7976664185024';
  const slackPermissions = 'openid,profile';

  const onSlackLinkClick = () => {
    actions.createVectorStorage((data) => {
      const vectorStorageId = data.attributes.vector_storage_id;

      const redirectUri = encodeURIComponent(
        'https://6jbebkb51g.execute-api.us-east-2.amazonaws.com/v1/api/v1/slack/auth?'
        + `user_id=${stateUsers.user.attributes.slack_user_id}&`
        + `back_url=${stateUsers.user.attributes.slack_back_url}&`
        + `vector_storage_id=${vectorStorageId}`,
      );

      document.location.href = `https://slack.com/openid/connect/authorize?scope=${slackPermissions}`
                + `&response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}`;
    });
  };

  return (
    <div className="mt-4">
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <p>
            Connect your Slack workspace to receive personalized coaching
            messages and interact with your LeggUP AI Health and Performance
            Coach directly through Slack.
          </p>
          <p>
            Click the Slack button to securely link your account and
            choose where you&apos;d like to receive coaching notifications.
          </p>
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-end">
            <Button
              // onClick={onDeleteAccount}
              variant="outline-primary"
              onClick={onSlackLinkClick}
            >
              Slack
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
